/**
 * New typescript file
 */
import { Component, Input, Output, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { FieldMap } from './../../../../interfaces/fieldMap.interface'
import { CacheService } from '../../../../../services/sys/cache.service';
import { LocaleService } from '../../../../../services/ui/locale.service';
import { StringToStringMap } from '../../../../interfaces/string-string-map.interface';

declare var jQuery: any;

@Component({
    selector: 'gd-field-dropdown',
    templateUrl: 'gd-field-dropdown.component.html',
    styleUrls: ['gd-field-dropdown.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class GdFieldDropdownComponent implements OnInit {
    @Input() gdFieldId: string;
    
    @Input() gdModel: string;
    
    @Output() gdModelChange: EventEmitter<any> = new EventEmitter<any>();
    
    @Input() gdShowFlag: boolean = true;
    
    @Input() gdDisableHook: string;
    
    @Input() gdLabel:    string;
    
    @Input() gdAddClass: string;
    
    @Input() gdDisabled: boolean = false;
    
    @Input() gdHideLabel: boolean = false;

    @Input() gdStyleNextGen: boolean = false;
    
    @Input() gdErrorImgAlt: string;
        
    @Input() gdMaxLength: number;
    
    @Input() fieldMap: FieldMap;
    
    @Input() gdOptions: {value: string, display: string, disabled?: boolean, hidden?: boolean}[];
  
    @Input() gdShowLabel: boolean = false;
	
	@Input() gdLabelA: string;
	
	@Input() gdLabelB: string;
	
	@Input() gdLabelC: string;
		
	//link to external link
	@Input() gdShowLabelExternalLink: boolean = false;
	
	@Input() gdLabelExternalLink: string;
        
    @Input() set gdAriaLabelledby(arialLebelledbyIds) {
        this.ariaLabelledby = this.gdFieldId + "GroupLabel";
        if(arialLebelledbyIds !== undefined && arialLebelledbyIds !== null) {
            this.ariaLabelledby = this.ariaLabelledby + " " + arialLebelledbyIds;
        }
    };
  
    //OK confirm web link
    @Input() confirmWebIndex: string;
    @Output() updateConfirmWeb: EventEmitter<any> = new EventEmitter<any>();
	@Output() floatingButtonClicked: EventEmitter<any> = new EventEmitter<any>();
    
    @Output() gdFocus: EventEmitter<void> = new EventEmitter<void>();
	@Output() gdTabOutput: EventEmitter<any> = new EventEmitter<any>();
    
    ariaLabelledby: string;
    private componentText: StringToStringMap<string> = {};
    
    constructor(private cacheService: CacheService,
				private localeService: LocaleService) {

    }
    
	ngOnInit(){
		this.gdModel = (this.gdModel == undefined || this.gdModel == null) ? "" : this.gdModel;
        this.componentText['assumedLabel'] = "not sure herereerere";
	};
	
    outputGdModel() {
        this.gdModelChange.emit(this.gdModel);
    }
    //emit OK click event
    confirmWeb(confirmationFieldId){
        this.updateConfirmWeb.emit(this.confirmWebIndex);
		jQuery("#" + confirmationFieldId).focus();
    };
    /**
	toggleRightKey(helpFile, event){
		if(event.code == "Enter"){
			this.helpService.startHelpSidenav(helpFile);
		};
	};
	
	toggleRight(helpFile) {
        this.helpService.startHelpSidenav(helpFile);
        return false;
    };
  **/    
    onFocus() {
        this.gdFocus.next();
    };
    
    onTab() {
        this.gdTabOutput.emit();
    };
}